<script>
    export let holidays;
    holidays = holidays ?? [];

    function formatTime (hhmm) {
        if (!(typeof hhmm == "string")){
            console.warn("Zu formatierende Uhrzeit ist nicht vom Typ String.")
            return;
        }
        return (hhmm.slice(0, 2)+":"+hhmm.slice(2, 4));
    }
</script>


<div class="container">
    <span class="day">Feiertags</span>
    <div class="periods">
        {#if holidays?.length > 0}
            {#each holidays as period}
                <span>{formatTime(period.open?.time)??"--:--"} - {formatTime(period.close?.time)??"--:--"}</span>
            {/each}
        {:else if holidays}
            <span class="closed">geschlossen</span>
        {:else}
            <span class="closed">regulär geöffnet</span>
        {/if}
    </div>
</div>


<style>
    .container {
        display: grid;
        grid-template-columns: [day] 12ch [slots] auto [end];
        grid-template-rows: auto;
        padding: 0.5rem 0;
    }

    /* .container:not(:last-of-type) {
        border-bottom: 1px solid #eee;
    } */

    .day {
        grid-area: day;
        align-self: center;
    }

    .periods {
        grid-area: slots;
        justify-self: end;
    }

    .periods>span {
        display: block;
        margin: 0.5rem 0;
    }

    .closed {
        grid-area: slots;
        justify-self: end;
        font-style: italic;
    }
</style>